<template>
  <div class="container">
    <BillingPlan v-if="!stripeCheckout"></BillingPlan>
    <BillingCheckout v-else-if="stripeCheckout"></BillingCheckout>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
const BillingPlan = () =>
  import("../components/stripe-checkout/AdminBillingPlan");
const BillingCheckout = () =>
  import("../components/stripe-checkout/AdminBillingCheckout");

export default {
  components: {
    BillingPlan,
    BillingCheckout
  },
  created() {
    this.SET_STRIPE_CHECKOUT(null);
  },
  computed: {
    stripeCheckout() {
      return this.$store.state.concierge.stripeCheckout;
    }
  },
  methods: {
    ...mapActions({
      SET_STRIPE_CHECKOUT: "SET_STRIPE_CHECKOUT"
    }),
    ...mapGetters({
      getStripeCheckout: "getStripeCheckout"
    })
  }
};
</script>

<style lang="scss" scoped>
.mb-30 {
  margin-bottom: 30px;
}
</style>
